import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'

import { IconBox } from './styles'

/**
 * EarthMarker
 *
 * @param {object} props - properties of component
 * @returns {node} EarthMarker
 */
const EarthMarker = ({ isVisible }) => (
  <IconBox {...{ isVisible }}>
    <Icon id="color_ancestry" />
  </IconBox>
)

EarthMarker.propTypes = {
  isVisible: PropTypes.bool,
}

EarthMarker.defaultProps = {
  isVisible: false,
}

export default EarthMarker
